/* global System */
import { Logger } from './Logger';

const importModalApi = async () => {
  try {
    const modalNorthboundApi = await System.import(
      '@clientos/modal-northbound-api'
    );
    Logger.log('Successfully loaded modalNorthboundApi');
    return modalNorthboundApi.default;
  } catch (error) {
    Logger.log('Failed to load modalNorthboundApi:', error);
    throw error;
  }
};

export const closeModal = async () => {
  try {
    const modalApi = await importModalApi();
    modalApi.v1.close();
  } catch (error) {
    Logger.log('Failed to close modal:', error);
    throw error;
  }
};
